export function reverseUrl(name, ...args) {
    if (window.reverseUrl) {
        try {
            return window.reverseUrl(name, ...args);
        } catch (e) {
            return 'error:The URL could not be reversed. Try refreshing your browser.';
        }
    } else {
        throw new Error('The URL reversing module is not initialized.');
    }
}

export function getAbsoluteUrl(relativeUrl) {
    const url = new URL(relativeUrl, document.baseURI);
    return url.href;
}

export function staticUrl(url) {
    return window.EODSUN_STATIC_PREFIX + url;
}